// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__24XYd","productName":"Table_productName__1n9bU"};